import React from 'react';
import { Typography, useTheme } from '@mui/material';
import AlertDialog from '../../../../components/AlertDialog';
import {
  INVITEE_ACCEPTED_PAGE,
  INVITEE_ALREADY_EVALUATED_PAGE,
  INVITEE_CATEGORY,
  INVITEE_REJECTED_PAGE,
} from './analyticsPages';
import { inviteeResultCopy } from './copy';

type ComplementLeadResultDialogProps = {
  leadComplementAccepted?: boolean;
  ownPreApproved?: boolean;
  leadFirstName?: string;
  alreadyEvaluated?: boolean;
  partnerName?: string;
};

export default function ComplementLeadResultDialog({
  leadComplementAccepted,
  ownPreApproved = false,
  leadFirstName,
  alreadyEvaluated = false,
  partnerName,
}: ComplementLeadResultDialogProps) {
  const theme = useTheme();
  if (!alreadyEvaluated && typeof leadComplementAccepted !== 'boolean') return null;

  const copy = inviteeResultCopy({
    leadComplementAccepted,
    ownPreApproved,
    leadFirstName,
    alreadyEvaluated,
    partnerName,
  });

  let analyticsName = INVITEE_REJECTED_PAGE;
  if (alreadyEvaluated) {
    analyticsName = INVITEE_ALREADY_EVALUATED_PAGE;
  } else if (leadComplementAccepted) {
    analyticsName = INVITEE_ACCEPTED_PAGE;
  }

  return (
    <AlertDialog
      isTriggered
      hideSubmitButton
      maxWidth="xs"
      closeButtonLabel="Entendido"
      pageCall={{
        category: INVITEE_CATEGORY,
        name: analyticsName,
        props: {
          accepted: String(leadComplementAccepted),
          ownPreApproved: String(ownPreApproved),
          alreadyEvaluated: String(alreadyEvaluated),
        },
      }}
      dialogTitle={(
        <Typography
          data-pw="complement-lead-result-title"
          variant="body1"
          fontWeight="bold"
          align="center"
          component="div"
          style={{ margin: 16 }}
        >
          {copy.title}
        </Typography>
      )}
      dialogContent={(
        <>
          {copy.body.map((paragraph) => {
            if (typeof paragraph === 'string') {
              return (
                <Typography
                  key={paragraph}
                  variant="body2"
                  align="center"
                  component="div"
                  style={{ margin: 16 }}
                >
                  {paragraph}
                </Typography>
              );
            }
            if ('rest' in paragraph) {
              return (
                <Typography
                  key={paragraph.bold}
                  variant="body2"
                  align="center"
                  component="div"
                  style={{ margin: 16 }}
                >
                  <b>{paragraph.bold}</b>
                  {paragraph.rest}
                </Typography>
              );
            }
            if ('before' in paragraph) {
              return (
                <Typography
                  key={paragraph.bold}
                  variant="body2"
                  align="center"
                  component="div"
                  style={{ margin: 16 }}
                >
                  {paragraph.before}
                  <b>{paragraph.bold}</b>
                  {paragraph.after}
                </Typography>
              );
            }
            return (
              <Typography
                key={paragraph.italicGray}
                variant="body2"
                align="center"
                component="div"
                style={{
                  margin: 16,
                  fontStyle: 'italic',
                  color: theme.palette.text.secondary,
                }}
              >
                {paragraph.italicGray}
              </Typography>
            );
          })}
        </>
      )}
    />
  );
}

ComplementLeadResultDialog.defaultProps = {
  leadComplementAccepted: undefined,
  ownPreApproved: false,
  leadFirstName: undefined,
  alreadyEvaluated: false,
  partnerName: undefined,
};
